import React, { forwardRef } from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import styles from "../Styles/ui/Label.module.css";

const Label = forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={`${styles.label} ${className}`}
    {...props}
  />
));

Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
